var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background":"#fff"}},[_c('div',{staticClass:"chat-widget"},[_c('div',{attrs:{"id":"chat-widget-container"}})])])
}]

export { render, staticRenderFns }